import jwtAuthAxios from "./auth/jwtAuth";

const tripLabelServices = {};

// Pendientes por viaje, para el icono QR de Viajes: { kinds: [...], trips: { [tripId]: { total, pending } } }.
tripLabelServices.getSummary = async (tripIds) => {
    const { data } = await jwtAuthAxios.get('/trip_labels', {
        params: { trip_ids: tripIds, summary: 1 },
    });
    return data;
};

// Desglose por viaje y pedido: por rango de fecha de despacho o por viajes puntuales.
tripLabelServices.getTripLabels = async ({ from, to, tripIds } = {}) => {
    const { data } = await jwtAuthAxios.get('/trip_labels', {
        params: tripIds?.length ? { trip_ids: tripIds } : { from, to },
    });
    return data;
};

export default tripLabelServices;
